// Central SEO config for category & product pages.
// Also consumed by scripts/prerender.js at build time (pure data/functions only).

export const slugify = (s) =>
    (s || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");

export const productPath = (product) => `/produit/${slugify(product.id)}/`;

export const CATEGORY_SEO = {
    rotative: {
        categoryId: "rotative",
        label: "Instrumentation Rotative",
        slug: "instrumentation-rotative",
        path: "/instrumentation-rotative/",
        metaTitle: "Turbines Dentaires et Instrumentation Rotative au Maroc | DENTIPRIME",
        metaDescription:
            "Turbines dentaires, contre-angles et pièces à main au Maroc. Compatibles KaVo, NSK, W&H. Fournisseur de matériel dentaire, livraison nationale 24h-72h.",
        h1: "Turbines et instrumentation rotative professionnelle au Maroc",
        intro: "Turbines haute vitesse, contre-angles et pièces à main compatibles KaVo, NSK et W&H : l'instrumentation rotative de référence pour les cabinets dentaires au Maroc, avec SAV et livraison nationale 24h-72h.",
    },
    implanto: {
        categoryId: "implanto",
        label: "Implantologie",
        slug: "implantologie",
        path: "/implantologie/",
        metaTitle: "Matériel d'Implantologie au Maroc | DENTIPRIME",
        metaDescription:
            "Matériel d'implantologie dentaire au Maroc : moteurs implantaires, trousses chirurgicales et contre-angles 20:1. Fournisseur dentaire, livraison nationale 24h-72h.",
        h1: "Matériel d'implantologie dentaire au Maroc",
        intro: "Moteurs implantaires, trousses chirurgicales et contre-angles réducteurs : du matériel d'implantologie précis et garanti, livré aux cabinets et cliniques partout au Maroc, avec support technique francophone.",
    },
    endo: {
        categoryId: "endo",
        label: "Endodontie",
        slug: "endodontie",
        path: "/endodontie/",
        metaTitle: "Matériel d'Endodontie au Maroc | DENTIPRIME",
        metaDescription:
            "Matériel d'endodontie professionnel au Maroc : endomoteurs, localisateurs d'apex, limes NiTi et irrigation. Fournisseur dentaire, livraison nationale 24h-72h.",
        h1: "Matériel professionnel d'endodontie au Maroc",
        intro: "Endomoteurs, localisateurs d'apex, limes NiTi rotatives et accessoires d'irrigation : DENTIPRIME équipe les cabinets dentaires marocains en matériel d'endodontie fiable, avec SAV et livraison nationale 24h-72h.",
    },
    conso: {
        categoryId: "conso",
        label: "Consommables",
        slug: "consommables-dentaires",
        path: "/consommables-dentaires/",
        metaTitle: "Consommables Dentaires au Maroc | DENTIPRIME",
        metaDescription:
            "Consommables dentaires professionnels au Maroc : composites, adhésifs, alginates, fraises et produits de désinfection. Livraison nationale 24h-72h.",
        h1: "Consommables dentaires professionnels au Maroc",
        intro: "Composites, adhésifs, alginates, fraises et produits d'hygiène : vos consommables dentaires livrés partout au Maroc en 24h-72h, avec un stock vérifié quotidiennement.",
    },
};

export const categorySeoBySlug = Object.fromEntries(
    Object.values(CATEGORY_SEO).map((c) => [c.slug, c])
);

export const categorySeoByLabel = Object.fromEntries(
    Object.values(CATEGORY_SEO).map((c) => [c.label, c])
);
